/**
 * @desc 条件查询sku列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmSkuListResponseDto>>;
export function request(
  body: defs.basics.PlmSkuRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/findList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
